// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1jnwE","Success":"Button_Success__1Imaa","Danger":"Button_Danger__LfkHN"};